export default __webpack_public_path__ + "static/media/KOL-SHARENA DELON.090b1dfe.jpg";